import { render, staticRenderFns } from "./copyBottun.vue?vue&type=template&id=2cba4516"
import script from "./copyBottun.vue?vue&type=script&lang=js"
export * from "./copyBottun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports